var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import * as Styled from "./OverlayStyles";
import { withTheme } from "styled-components";
var Overlay = function (_a) {
    var _b = _a.level, level = _b === void 0 ? 1 : _b, _c = _a.zIndex, zIndex = _c === void 0 ? "auto" : _c, theme = _a.theme, style = _a.style, props = __rest(_a, ["level", "zIndex", "theme", "style"]);
    if ((theme === null || theme === void 0 ? void 0 : theme.themeName) === "dark") {
        return (React.createElement(Styled.Overlay, __assign({ level: level, zIndex: zIndex, style: style }, props)));
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
export default withTheme(Overlay);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3ZlcmxheS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIk92ZXJsYXkudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEtBQUssS0FBSyxNQUFNLE9BQU8sQ0FBQztBQUMvQixPQUFPLEtBQUssTUFBTSxNQUFNLGlCQUFpQixDQUFDO0FBQzFDLE9BQU8sRUFBZ0IsU0FBUyxFQUFFLE1BQU0sbUJBQW1CLENBQUM7QUFTNUQsSUFBTSxPQUFPLEdBQUcsVUFBQyxFQU1OO0lBTFQsSUFBQSxhQUFTLEVBQVQsS0FBSyxtQkFBRyxDQUFDLEtBQUEsRUFDVCxjQUFlLEVBQWYsTUFBTSxtQkFBRyxNQUFNLEtBQUEsRUFDZixLQUFLLFdBQUEsRUFDTCxLQUFLLFdBQUEsRUFDRixLQUFLLGNBTE8scUNBTWhCLENBRFM7SUFFUixJQUFJLENBQUEsS0FBSyxhQUFMLEtBQUssdUJBQUwsS0FBSyxDQUFFLFNBQVMsTUFBSyxNQUFNLEVBQUU7UUFDL0IsT0FBTyxDQUNMLG9CQUFDLE1BQU0sQ0FBQyxPQUFPLGFBQUMsS0FBSyxFQUFFLEtBQUssRUFBRSxNQUFNLEVBQUUsTUFBTSxFQUFFLEtBQUssRUFBRSxLQUFLLElBQU0sS0FBSyxFQUFJLENBQzFFLENBQUM7S0FDSDtTQUFNO1FBQ0wsT0FBTyxvQkFBQyxLQUFLLENBQUMsUUFBUSxPQUFrQixDQUFDO0tBQzFDO0FBQ0gsQ0FBQyxDQUFDO0FBRUYsZUFBZSxTQUFTLENBQUMsT0FBTyxDQUFDLENBQUMifQ==